import { ContainersSettings } from "~/pages/settings/components/containers";
import { useSelectedCompany } from "~/shared/store/company/hooks/useSelectedCompany";

const InventoryPage = () => {
  const selected_company = useSelectedCompany();
  return (
    <ContainersSettings selectedCompanyId={selected_company?.selectedCompanyId || undefined} />
  );
};

export default InventoryPage;
